import { schema } from "normalizr";
import { ChartOfAccountArraySchema } from "./index";

const ChartOfAccountTypeSchema = new schema.Entity("chartOfAccountTypes", {
  chartAccounts: ChartOfAccountArraySchema
});

const ChartOfAccountTypeArraySchema = new schema.Array(ChartOfAccountTypeSchema);

export { ChartOfAccountTypeSchema, ChartOfAccountTypeArraySchema };